import { LayerType } from '@pn/core/domain/layer';
import { buildQuery } from '@pn/core/domain/query';
import {
  createInitInternalState,
  ItemsFolder,
  type WorkspaceItem,
} from '@pn/core/domain/workspace';
import { isProduction } from '@pn/core/utils/env';
import { DEFAULT_POLYGON_OPACITY } from '@pn/services/styles';
import { generateMapConfig, setOriginalLayers } from '.';

export const mineral_rights: WorkspaceItem = setOriginalLayers({
  country: 'canada',
  folder: ItemsFolder.Public,
  isTemporary: false,
  id: 'mineral_rights',
  dataType: 'mineral_rights',
  itemType: 'layer',
  numberOfElements: undefined,
  createdBy: undefined,
  name: 'Mineral Rights',
  description: '110k lands in Canada',
  origin: 'pn',
  createdAt: '1970-01-01T00:00:00.000Z',
  updatedAt: '1970-01-01T00:00:00.000Z',
  isShared: false,
  isGlobal: true,
  map: generateMapConfig({
    itemId: 'mineral_rights',
    type: LayerType.Polygon,
    style: {
      color: `hsla(45, 100%, 50%, ${DEFAULT_POLYGON_OPACITY})`,
    },
    source: {
      type: 'vector',
      minzoom: 6,
      maxzoom: 10,
      tiles: [
        isProduction()
          ? 'https://tiles.stackdx.com/mineral_rights/{z}/{x}/{y}.pbf'
          : 'https://staging-tiles.stackdx.com/mineral_rights/{z}/{x}/{y}.pbf',
      ],
    },
    sourceLayer: 'mineral_rights',
    renderAsPoints: true,
  }),
  dataSource: {
    type: 'api',
    source: 'parquet',
    url: 'v2/layers/mineral_rights',
    requiredMapDataFields: ['internal_id', 'geometry'],
    requiredTableDataFields: [
      'internal_id',
      'geometry',
      'agreement_id',
      'tract',
      'status',
      'participants',
      'expiry_date',
    ],
  },
  detailsSource: 'api',
  query: buildQuery({
    id: 'mineral_rights',
    dataType: 'mineral_rights',
  }),
  ...createInitInternalState({ isVisualized: false }),
});
